export default {
  heading: {
    id: 'checkout_bouygues_magic_link_layout_expired_heading',
    defaultMessage: 'Le lien de confirmation a expiré',
  },
  generateNewLinkMessage: {
    id: 'checkout_bouygues_magic_link_expired_generate_new_link_message',
    defaultMessage:
      'Générez un nouveau lien de confirmation pour terminer votre achat.',
  },
  generateNewLinkCta: {
    id: 'checkout_bouygues_magic_link_expired_generate_new_link_cta',
    defaultMessage: 'Générer un nouveau lien',
  },
  changeYourMindTitle: {
    id: 'checkout_bouygues_magic_link_layout_change_your_mind_title',
    defaultMessage:
      'Vous ne voulez plus acheter l’appareil choisi en boutique ?',
  },
  renewalSuccessToastTitle: {
    id: 'checkout_bouygues_magic_link_layout_renewal_success_toast_title',
    defaultMessage: 'Nouveau lien généré !',
  },
  renewalSuccessToastContent: {
    id: 'checkout_bouygues_magic_link_layout_renewal_success_toast_content',
    defaultMessage:
      'Un nouveau lien de confirmation vient de vous être envoyé par email.',
  },
  magicLinkNotRenewable: {
    id: 'checkout_bouygues_magic_link_expired_and_not_renewable_message',
    defaultMessage: 'This magic link has expired and is no longer valid.',
  },
}
